const en = {
  translation: {
    messages: {
      title: "Messages",
      loading: "Loading…",
      sending: "Sending…",
      send: "Send",
      back: "Back",
      you: "You",
      input_placeholder: "Write a message…",
      thread_empty: "No messages in this thread yet. Break the ice.",
      load_more: "See earlier messages",
      select_conversation: "Pick a conversation to read it here.",
      compose_hint: "You're about to message {{name}}. Your first message opens the conversation.",
      message_action: "Message",
      send_error: "Couldn't send the message. Try again.",
      empty_title: "Your garage is still quiet",
      empty_body: "When you connect with another collector, the chat lives here. Drop by a profile and start the exchange.",
      now: "now",
      min_ago: "{{count}} min ago",
      hour_ago: "{{count}} h ago",
      yesterday: "yesterday",
      days_ago: "{{count}} d ago",
    },
    nav: {
      explore: "Explore",
      auctions: "Auctions",
      community: "Community",
      login: "Sign In",
      upload: "Upload",
      bulk_upload: "Upload multiple pieces",
      panel: "Dashboard",
      messages: "Messages",
      language: "Language",
      pricing: "Pricing",
    },
    pricing: {
      meta_title: "Pricing — Troly",
      meta_desc: "Troly plans for collectors, sellers, and brands.",
      eyebrow: "Plans",
      title: "Choose your plan",
      subtitle: "Start free. Grow when your collection asks for it.",
      per_year: "/yr",
      per_month_equiv: "≈ {{price}}/mo",
      custom_price: "Custom pricing",
      badge_popular: "Most popular",
      badge_current: "Your current plan",
      free: "Free",
      free_forever: "forever",
      cta_start: "Start now",
      cta_sales: "Contact sales",
      wa_sales_message: "Hi, I'm interested in the Troly Seller plan. Could you share more information?",
      cta_loading: "Redirecting to Stripe…",
      cta_manage: "Manage subscription",
      checkout_error: "We couldn't start the checkout. Please try again.",
      plans: {
        pro: {
          name: "Troly Pro",
          tagline: "For the active collector",
          note: "Meet more collectors, no card required",
          features: [
            "Upload pieces and organize your collection",
            "Duplicate piece alert",
            "Community access",
            "Messaging between collectors",
            "Search pieces and check their price",
          ],
        },
        premium: {
          name: "Troly Premium",
          tagline: "For collectors who also sell and trade",
          note: "Join the club and live a different experience",
          features: [
            "Everything in Pro",
            "Public collection profile",
            "Mark pieces as for sale, trade, or display only",
            "User verification badge",
            "Gain followers for your collection",
          ],
        },
        seller: {
          name: "Troly Seller",
          tagline: "For sellers, distributors, and brands",
          desc: "We build the tools your operation needs: seller analytics, integrations, dedicated support, and guaranteed SLA.",
          features: [
            "Everything in Premium",
            "Seller analytics (conversion, demand)",
            "Custom integrations",
            "Dedicated support and guaranteed SLA",
            "Automatic alerts to your followers when you list pieces for sale",
          ],
        },
      },
    },
    premium_success: {
      meta_title: "Welcome to Troly Premium — Troly",
      eyebrow: "Troly Premium",
      verifying_title: "Confirming your payment…",
      verifying_text: "We're verifying your subscription with Stripe. This only takes a few seconds.",
      title: "You're Premium now!",
      text: "Your subscription is active. Enjoy your public profile, mark pieces for sale or trade, and show off your trust badge.",
      cta_profile: "Go to my profile",
      error_title: "We couldn't confirm the payment",
      error_text: "If you were charged, your account will update automatically within a few minutes. Otherwise, try again from the pricing page.",
      cta_back: "Back to pricing",
    },
    navbar: {
      search_placeholder: "Search pieces, brands, collectors...",
      searching: "Searching…",
      no_results: "No results for",
      pieces: "Pieces",
      collectors: "Collectors",
      see_all_results: "View all results",
      home: "Home",
      light_mode: "Light mode",
      dark_mode: "Dark mode",
      admin: "Admin",
      language: "Language",
      my_profile: "My Profile",
      cart: "Cart",
      settings: "Settings",
      logout: "Sign out",
    },
    home: {
      hero_eyebrow: "ONE APP, YOUR WHOLE COLLECTION",
      hero_title: "Know what",
      hero_accent: "your collection is worth.",
      hero_sub: "From your first piece to your most wanted grail, Troly keeps everything you collect in one place — and tells you what it's worth, in your currency.",
      meta_title: "Troly — Know what your collection is worth",
      meta_desc: "Organize your die-cast collection, see its total value in your currency and connect with other collectors.",
      filters: {
        all: "All Models",
        sale: "For Sale",
        trade: "For Trade",
        display: "Display Only",
        classic: "Classics",
        hypercar: "Hypercars",
      },
      search_query_chip: "Search",
      clear_search: "Clear search",
      loading: "Loading pieces…",
      load_error: "We couldn't load the catalog. Please try again in a few minutes.",
      empty_category: "No pieces yet in this category.",
      community: "Community",
      search_placeholder: "Search classics, exotics...",
      features: {
        eyebrow: "WHY TROLY",
        title: "Everything your collection needs",
        subtitle: "Add it once and Troly handles the rest: what it's worth, how you organize it and who you share it with.",
        value_title: "Your collection's value, always at hand",
        value_desc: "Every piece you add counts toward your Total Value. Troly calculates it from catalog prices and shows it in your currency.",
        value_cta: "See my total value",
        prices_title: "Catalog prices",
        prices_desc: "Search any piece and check its price before you buy, sell or trade it.",
        prices_cta: "Explore the catalog",
        organize_title: "Your garage, organized",
        organize_desc: "Folders, scales and filters to find any piece in seconds, no matter how big your collection gets.",
        organize_cta: "Add my pieces",
        trade_title: "For sale or for trade",
        trade_desc: "Mark the pieces you want to sell or trade and let other collectors find you.",
        trade_cta: "See plans",
        community_title: "A community of collectors",
        community_desc: "Public profile, followers and direct messages with people who collect what you collect.",
        community_cta: "Meet the club",
      },
      footer: {
        tagline: "Organize your collection, know what it's worth and connect with other collectors.",
        platform: "Platform",
        company: "Company",
        legal: "Legal",
        raffle: "Raffle Terms",
        pricing: "Pricing",
        security: "Security",
        about: "About",
        blog: "Blog",
        careers: "Careers",
        privacy: "Privacy",
        terms: "Terms",
        copyright: "© 2026 TROLY MARKETPLACE · ALL RIGHTS RESERVED",
      },
    },
    trigger: {
      title: "Exclusive club for car collectors",
      desc: "Joining is free and no card details are required. We only verify your email with a code to maintain the quality and security of the community.",
      have_code: "I have an invitation code",
      join_waitlist: "Join the club",
      have_account: "I already have an account",
      fast_track_divider: "FAST TRACK",
      fast_track_text: "Fast-track your access. Verify your profile with Facebook and we'll send your invite code instantly.",
      fb_button: "Continue with Facebook",
      fb_loading: "Connecting to Facebook…",
      fb_cancelled: "You cancelled the Facebook sign-in.",
      fb_error: "We couldn't complete the Facebook sign-in.",
      fb_sdk_error: "Failed to load Facebook. Please try again.",
      fb_email_required: "Your Facebook account has no email attached. Please use another sign-in option.",
      fb_not_configured: "Facebook sign-in is not available yet.",
    },
    invite_code: {
      title: "Enter your invitation code",
      desc_l1: "We've sent a verification code to your email.",
      desc_l2: "Check your inbox or spam folder.",
      from_fb_hint: "We sent your invitation code to {{email}}. Check your inbox or spam folder.",
      err_incomplete: "Enter all 6 characters",
      err_invalid: "Invalid code",
      validate: "Validate",
      validating: "Validating...",
      resend: "Resend code",
    },
    waitlist: {
      badge: "Coming soon",
      title: "You're one step away from the club",
      desc: "Leave us your email and we'll send you your access code instantly.",
      email_placeholder: "Enter your email",
      err_no_email: "Enter your email",
      err_register: "Registration error",
      submit: "Send me my code",
      submitting: "Registering...",
      wait_label: "Wait time:",
      wait_value: "0 days",
    },
    waitlist_done: {
      title: "You're in line for the club",
      received: "Registration received!",
      you_are: "You are collector",
      in_queue: "in line",
      skip_title: "Want to skip the line?",
      skip_desc: "Find a friend who's already in Troly and ask for one of their invitations.",
      have_code_btn: "I have a code",
    },
    login_pg: {
      welcome: "Welcome back",
      err_invalid: "Invalid credentials",
      email_label: "Email address",
      email_placeholder: "name@example.com",
      password_label: "Password",
      forgot: "I forgot my password",
      submit: "Sign in",
      submitting: "Signing in...",
      no_account: "Don't have an account yet?",
      register: "Sign up",
    },
    register_pg: {
      title: "Create your digital garage",
      subtitle: "Your Troly Pro plan is free, forever. No card required.",
      err_pass_mismatch: "Passwords do not match",
      err_loc_required: "Enter your city and country",
      err_register: "Registration error",
      name_label: "FULL NAME",
      name_placeholder: "Your name",
      email_label: "EMAIL ADDRESS",
      email_placeholder: "email@example.com",
      password_label: "PASSWORD",
      confirm_label: "CONFIRM PASSWORD",
      city_label: "CITY",
      city_placeholder: "New York",
      country_label: "COUNTRY",
      country_placeholder: "United States",
      code_label: "INVITATION CODE",
      code_placeholder: "XXX-XXX",
      email_locked_hint: "Verified with Facebook",
      submit: "Create account →",
      submitting: "Creating account...",
      have_account: "Already have an account?",
      login_link: "Sign in",
    },
    auth_shell: {
      copyright: "© 2026 TROLY HIGH PERFORMANCE COLLECTIBLES",
    },
    auth: {
      welcome_back: "Welcome back",
      welcome_sub: "Access your private collector vault",
      google: "Continue with Google",
      facebook: "Continue with Facebook",
      or_email: "OR SIGN IN WITH EMAIL",
      email_label: "EMAIL ADDRESS",
      email_placeholder: "name@example.com",
      password_label: "PASSWORD",
      forgot: "Forgot your password?",
      login_btn: "Sign in",
      no_account: "Don't have an account?",
      register_link: "Sign up",
      create_title: "Create your digital garage",
      name_label: "FULL NAME",
      name_placeholder: "Your name",
      confirm_label: "CONFIRM PASSWORD",
      terms: "I accept the",
      terms_link: "Terms and Conditions",
      terms_and: "and privacy policy.",
      register_btn: "Create account",
      have_account: "Already have an account?",
      login_link: "Sign in",
    },
    profile: {
      invite: "Invite friends",
      total_value: "TOTAL VALUE",
      pieces: "PIECES",
      unique: "Unique models",
      followers: "FOLLOWERS",
      following: "FOLLOWING",
      collectors: "Collectors",
      my_collection: "My Collection",
      see_all: "See full collection",
      filters: { all: "All" },
      scale_all: "All",
      usd_estimated: "Est. USD",
      hidden_public: "hidden from public",
      in_garage: "in your garage",
      for_sale: "FOR SALE",
      active: "active",
      trade: "TRADE",
      available: "available",
      enter_raffle: "Enter the raffle",
      invite_friend: "Invite a friend",
      upgrade_plan: "Upgrade plan",
      seller_badge: "TROLY SELLER",
      seller_panel: "Seller dashboard",
      seller_request_pending: "Request pending",
      seller_request_sending: "Sending…",
      seller_request: "Request to become a seller",
      seller_request_again: "Request to become a seller (again)",
      seller_request_rejected_title: "Your previous request was rejected — you can request again",
      seller_request_auto: "You listed a piece for sale, so we sent your seller request to the Troly admin team. You need to wait for it to be approved; you will find the details in your messages and your email.",
      hide_public: "Hide from public",
      show_public: "Show to public",
      loading_collection: "Loading your collection…",
      no_pieces: "You haven't uploaded any pieces yet. ",
      no_in_scale: "No pieces at this scale. ",
      upload_first: "Upload the first one",
      collections_label: "Folders",
      collection_all: "All",
      collection_new: "+ New folder",
      collection_manage: "Manage folders",
      collection_empty_filter: "No pieces in this folder. Tap the 📁 icon on a piece to assign it.",
      collection_modal: {
        new_title: "New folder",
        edit_title: "Edit folder",
        name_label: "Name",
        name_placeholder: "e.g. JDM Classics",
        desc_label: "Description (optional)",
        public_label: "Visible on my public profile",
        save: "Save",
        saving: "Saving…",
        cancel: "Cancel",
        delete: "Delete folder",
        delete_confirm: "Delete this folder? Pieces won't be deleted, just removed from the folder.",
      },
      pub_folders_modal: {
        title: "Folders for this piece",
        empty: "You don't have any folders yet. Create one from the folders section.",
        save: "Save",
        saving: "Saving…",
      },
      pub_folders_btn: "Folders",
      free_modal: {
        title: "Enter the next raffle",
        unlocked: "🎉 You are in! Your entry is active. Keep inviting: every four registered collectors earn you another number.",
        intro: "Upload four pieces and you get your number. After that, every four collectors you invite earn you an extra one:",
        step1: "Upload at least four pieces from your own collection — that earns you your number",
        step2: "Share your personal code with other collectors:",
        step3: "Every four who complete their sign-up earn you one more number",
        your_numbers: "Your numbers",
        next_number: "{{count}} more referrals for your next number.",
        label_referrals: "Registered referrals",
        label_pieces: "Pieces uploaded",
        foot: "Numbers are assigned automatically, no paperwork. The winner will be announced live on our Facebook page.",
        territory_note: "Raffle open to collectors in {{territory}}.",
        email_placeholder: "email@example.com",
        cancel: "Cancel",
        sending: "Sending…",
        send: "Send",
        share_email: "Share by email",
        share_whatsapp: "Share via WhatsApp",
        sent_to: "Invitation sent to {{email}} ✓",
        err_invalid_email: "Enter a valid email.",
        err_send_failed: "We couldn't send the email. Please try again.",
        wa_message: "I'm inviting you to Troly, the club for scale model car collectors. Use my code {{code}} to join: {{url}}",
      },
      invite_modal: {
        title: "Invite a friend to Troly",
        intro: "Generate a single-use code so a friend can sign up on Troly. Share it by email or WhatsApp.",
        remaining_one: "You have {{count}} invitation left.",
        remaining_other: "You have {{count}} invitations left.",
        none_left: "You have no invitations available right now.",
        code_generated: "Your invitation code:",
        email_placeholder: "email@example.com",
        cancel: "Cancel",
        sending: "Sending…",
        send: "Send",
        share_email: "Invite by email",
        share_whatsapp: "Invite via WhatsApp",
        sent_to: "Invitation sent to {{email}} ✓",
        err_invalid_email: "Enter a valid email.",
        err_send_failed: "We couldn't send the email. Please try again.",
        err_generate_failed: "We couldn't generate the invitation. Please try again.",
        wa_message: "I'm inviting you to Troly, the club for scale model car collectors. Use my invitation code {{code}} to join: {{url}}",
      },
      member_chip: {
        title: "Your member number",
        text: "You're member #{{number}} of Troly",
      },
    },
    upload: {
      title: "New Piece",
      subtitle: "Complete the technical details to publish your piece in Troly's catalog.",
      drop_title: "Drag photos here",
      drop_sub: "Supports JPG, PNG up to 10MB per image",
      name_label: "Piece name",
      name_placeholder: "Pontiac GTO 1967",
      year_label: "Year",
      year_placeholder: "2024",
      sku_label: "SKU (Toy Number)",
      sku_placeholder: "e.g. HNL21 / HW2024-001",
      brand_label: "Brand",
      brand_placeholder: "Select brand",
      scale_label: "Scale",
      scale_placeholder: "Select scale",
      action_label: "Action",
      action_placeholder: "Display (Share)",
      category_label: "Category",
      category_placeholder: "Select category",
      price_label: "Price",
      price_amount: "Price",
      price_currency: "Currency",
      negotiable: "Negotiable",
      material_label: "Material",
      material_placeholder: "Select material",
      desc_label: "Description",
      desc_placeholder: "Describe the piece's condition, technical compatibility, and additional details...",
      publish_btn: "Publish Piece",
      draft_btn: "Save Draft",
      tips_title: "TROLY TIPS",
      tip1: "Use natural lighting to highlight the material details.",
      tip2: "Specify the exact scale to avoid unnecessary returns.",
      tip3: "Pieces with authenticity certificates sell 40% faster.",
      err_publish: "Publishing failed",
      publishing: "Publishing...",
      select: "Select",
      action_options: { Mostrar: "Display", Venta: "Sale", Cambio: "Trade" },
      action_upgrade_notice: "You need to upgrade your plan to list pieces for sale or trade.",
      action_upgrade_link: "See plans",
    },
    settings: {
      meta_title: "Settings — Troly",
      title: "Settings",
      loading: "Loading…",
      photo_profile: "Photo and profile",
      upload_photo: "Upload photo",
      photo_hint: "JPG, PNG or WebP — max 5 MB.",
      bio_label: "Bio",
      bio_placeholder: "Briefly describe your collection…",
      location_label: "Location",
      location_placeholder: "Mexico City, Mexico",
      location_hint: "City and country. Used for dynamics like the raffle.",
      website_label: "Website",
      save_profile: "Save profile",
      change_password: "Change password",
      current_password: "Current password",
      new_password: "New password",
      confirm_new_password: "Confirm new password",
      update_password: "Update password",
      change_email: "Change email",
      current_email: "Current email:",
      new_email: "New email",
      confirm_password: "Confirm your password",
      change_email_btn: "Change email",
      session: "Session",
      logout: "Sign out",
      privacy: "Profile privacy",
      privacy_public_label: "Public profile",
      privacy_public_hint: "Your profile shows up in search and anyone can open it without signing up. Turn it off and only Troly members will see it.",
      privacy_total_label: "Show my collection's total value",
      privacy_total_hint: "Turn it off and the total value shows as hidden (“••••”) to everyone else.",
      privacy_prices_label: "Show the price of my pieces",
      privacy_prices_hint: "Turn it off and each piece's price stays hidden on your profile for visitors who are not signed in.",
      notifications: "Notifications",
      notif_messages_label: "Email me when I get messages",
      notif_messages_hint: "We'll send an email to your registered address when another collector writes to you on Troly.",
      comms_lang_label: "Language for Troly communications",
      comms_lang_hint: "The language we email you in: invitations, access codes, order alerts and trade offers.",
      comms_lang_auto: "Automatic (based on your location)",
      cancel_account: "Cancel account",
      cancel_account_warn: "This will delete your profile, your pieces and pending invitations. It can't be undone.",
      cancel_my_account: "Cancel my account",
      modal_title: "Cancel your account?",
      modal_warn: "This action will permanently delete your profile and your pieces.",
      modal_confirm_label: "Confirm with your password",
      back: "Back",
      delete: "Delete",
      msg: {
        privacy_ok: "Privacy preference saved.",
        privacy_err: "Could not save the privacy preference",
        notif_ok: "Preference saved.",
        notif_err: "Couldn't save the preference",
        comms_lang_ok: "Communications language saved.",
        comms_lang_err: "Couldn't save the communications language",
        photo_ok: "Photo updated.",
        photo_err: "Couldn't upload the image",
        profile_ok: "Profile saved.",
        profile_err: "Save failed",
        pw_required: "Enter your current and new password",
        pw_short: "New password must be at least 6 characters",
        pw_mismatch: "Confirmation does not match",
        pw_ok: "Password updated.",
        pw_err: "Failed to update password",
        email_required: "Enter the new email and your password",
        email_ok: "Email updated.",
        email_err: "Failed to change email",
        del_pw_required: "Confirm your password",
        del_err: "Failed to cancel the account",
      },
    },
    listing: {
      loading: "Loading piece...",
      not_found: "Piece not found",
      load_error: "Couldn't load this piece",
      no_image: "No image",
      image_alt: "Image",
      brand: "Brand",
      category: "Category",
      material: "Material",
      launch_year: "Launch year",
      sku: "SKU (Code)",
      scale: "Scale",
      action: "Action",
      location: "Location",
      views: "Views",
      description: "Description",
      paywall_desc: "The detailed description is available to Troly subscribers.",
      published_by: "Published by",
      collector: "Collector",
      price: "Price",
      paywall_logged: "Subscribe to Troly to see prices and buy.",
      paywall_anon: "Sign in and subscribe to see prices.",
      subscribe: "Subscribe",
      sign_in: "Sign in",
      price_low: "Low:",
      price_mid: "Mid:",
      price_high: "High:",
      market_value: "Reference value",
      market_value_note: "Market estimate — not a sale offer.",
      consult: "Inquire",
      contact_seller: "Contact seller",
      contact_owner: "Contact owner",
      traders_title: "Open to trade",
      contact_modal_title: "Contact the owner",
      contact_modal_subtitle: "We'll email them your message. Your email will be the sender so they can reply directly.",
      contact_modal_placeholder: "Hi, I'm interested in your piece. What would you like to trade for?",
      contact_modal_send: "Send message",
      contact_modal_cancel: "Cancel",
      contact_modal_sending: "Sending…",
      contact_modal_sent: "Message sent! The owner will receive your proposal by email.",
      contact_modal_error: "Couldn't send the email. Try again later.",
    },
    listing_card: {
      subscribe: "Subscribe",
      subscribe_tooltip: "Subscribe to see prices",
      action: { Venta: "SALE", Cambio: "TRADE", Mostrar: "DISPLAY" },
      add_to_cart: "Add to cart",
      view_cart: "View cart",
      contact_owner: "Contact owner",
    },
    admin: {
      loading: "Loading...",
      back: "Back",
      brand: "Troly · Admin",
      title: "Admin panel",
      subtitle_p1: "Manage the waitlist and invitations sent from",
      stat_total: "Waitlist total",
      stat_pending: "Pending",
      stat_invites_sent: "Invitations sent",
      stat_my_invites: "My invitations",
      tab_waitlist: "Waitlist",
      tab_invites: "Invitations sent",
      refresh: "Refresh",
      refreshing: "Refreshing...",
      loading_waitlist: "Loading waitlist...",
      empty_waitlist: "The waitlist is empty.",
      loading_invites: "Loading invitations...",
      empty_invites: "You haven't generated invitations yet.",
      th_email: "Email",
      th_registered: "Registered",
      th_status: "Status",
      th_code: "Code",
      th_sent_to: "Sent to",
      th_sent_by: "Sent by",
      th_created: "Created",
      th_used_by: "Used by",
      pill_registered: "Already registered",
      pill_code_sent: "Code sent",
      pill_waiting: "Waiting",
      pill_used: "Used",
      pill_expired: "Expired",
      pill_sent_pending: "Sent · pending",
      pill_send_failed: "Send failed",
      pill_code_only: "Code only",
      btn_resend: "Resend",
      btn_send_code: "Send code",
      btn_sending: "Sending...",
      sent_to: "Invitation sent to",
      err_load: "Error loading data",
      err_send: "Error sending invitation",
      not_sent: "— not sent",
      member_chip_title: "Member number badge",
      member_chip_on: "ON · Profiles show the \"You're member #N of Troly\" badge.",
      member_chip_off: "OFF · The member number badge is hidden for all users.",
      member_chip_aria: "Member number badge",
    },
    public_profile: {
      meta_desc: "Collection of {{name}} on Troly",
      loading: "Loading profile…",
      not_found: "Collector not found.",
      load_error: "We couldn't load this profile. Please try again.",
      his_collection: "Their Collection",
      go_to_panel: "Go to my panel",
      back_to_catalog: "Back to catalog",
      hidden_by_collector: "hidden by the collector",
      join_troly: "Join Troly",
      in_garage_his: "in their garage",
      empty: "This collector hasn't published any pieces yet.",
      empty_scale: "No pieces at this scale.",
    },
    share: {
      action: "Share",
      title: "Share profile",
      message: "Check out {{name}}'s collection on Troly",
      email_subject: "{{name}}'s collection on Troly",
      email: "Email",
      copy_link: "Copy link",
      copied: "Link copied!",
    },
    follow: {
      follow: "Follow",
      following: "Following",
      followers_count_one: "{{count}} follower",
      followers_count_other: "{{count}} followers",
      error: "Couldn't update follow status. Please try again.",
    },
    currency: {
      selector_label: "Display currency",
      original_published_in: "Published in {{currency}} {{amount}}",
    },
    terms: {
      meta_title: "Terms and Conditions — Troly",
      meta_desc: "Troly's Terms and Conditions of Use — the private club for collectors of scale cars and collectible vehicles.",
      back_to_home: "Back to home",
      title: "TROLY TERMS AND CONDITIONS OF USE",
      updated: "Last updated: May 2026",
      intro_p1: "Welcome to Troly. By accessing, registering on, or using our website at the domain (https://troly.club), you agree to comply with and be bound by these Terms and Conditions of Use. If you do not agree with these terms, you must refrain from using the platform.",
      intro_p2: "The platform is operated by Constructores de Crecimiento S.A. de C.V., identified by [ENTITY ID under formation], with its registered office at Residencial Alta Vitta, Anillo Interior Lomas Verdes 275, Código Postal 53124, Naucalpan de Juárez, Estado de México, hereinafter referred to as “The Company”. The Company also operates https://bido.app",
      s1: {
        num: "1",
        title: "DESCRIPTION OF SERVICES",
        intro: "Troly operates as a specialized marketplace and a digital community designed for collectors of scale cars and other collectible vehicles. The platform allows users to:",
        bullets: [
          "Create a personalized profile and configure their bio or contact channels.",
          "Upload images of their pieces to organize an interactive digital album.",
          "Tag each item with detailed technical specifications such as brand, model, scale, and estimated value.",
          "Interact with other community members by following profiles and through the comments section.",
          "Classify their items under specific dynamics such as display, trade, or direct sale.",
        ],
      },
      s2: {
        num: "2",
        title: "REGISTRATION AND ACCOUNT SECURITY",
        intro: "To access advanced publishing and interaction features, completing the registration process in the account creation interface is mandatory. The user agrees to:",
        bullets: [
          "Provide real, accurate, and up-to-date information when signing up on the platform.",
          "Safeguard the confidentiality of their access credentials.",
          "Assume full responsibility for any actions taken from their user profile.",
        ],
        outro: "The Company reserves the right to deactivate or suspend any accounts that show false data or suspicious activity that may affect the integrity of the community.",
      },
      s3: {
        num: "3",
        title: "BUSINESS MODEL AND SELLER SUBSCRIPTIONS",
        intro: "Troly operates under a marketplace model with a subscription for those users who wish to enable the direct sale functionality within the platform.",
        bullets: [
          { bold: "Seller Subscription:", text: "Members who decide to sell their pieces must keep an active recurring subscription plan (monthly or annual). The rates, features, and limits of each plan will be detailed explicitly in the user dashboard before proceeding with payment." },
          { bold: "Payment Processing via Stripe:", text: "All financial transactions arising from subscription sales or purchases of items between users will be processed exclusively through the Stripe payment gateway. By using this functionality, the user implicitly accepts Stripe's operational policies and terms of service." },
          { bold: "Transaction Fees:", text: "The Company reserves the right to apply a commission percentage on each successful sale made within the platform's ecosystem, which will be deducted automatically through the Stripe checkout flow. Current rates will be clearly indicated in the corresponding section of the portal." },
        ],
      },
      s4: {
        num: "4",
        title: "CONTENT UPLOAD CONDITIONS AND TECHNICAL REQUIREMENTS",
        intro: "When uploading photos or descriptions of their collection to the Troly server, the user warrants that they hold the necessary intellectual property rights over such material.",
        bullets: [
          { bold: "Image Optimization:", text: "To maintain loading speed and ensure optimal application performance, please limit the size of each uploaded image to a maximum of 3MB." },
          { bold: "Information Accuracy:", text: "The user must ensure that the required form fields (such as vehicle name, Code, SKU, brand, category, and material) faithfully match the actual physical piece. If the exact information is not available immediately, the user may enter a provisional value and correct it later through the listing editor." },
        ],
      },
      s5: {
        num: "5",
        title: "RESPONSIBILITY IN MARKETPLACE TRANSACTIONS",
        intro: "Troly provides the technological infrastructure to connect buyers and sellers within the community. However, The Company does not act as the owner, supplier, or manufacturer of the pieces displayed by users on their individual profiles.",
        intro2: "Consequently, The Company assumes no responsibility for:",
        bullets: [
          "The truthfulness of the specifications, physical condition, or authenticity of the cars listed by sellers.",
          "Logistical issues, delays, or losses associated with the shipping and physical distribution of products.",
          "Failure to comply with the tax or fiscal obligations corresponding to sales generated by each user in their local territory.",
        ],
      },
      s6: {
        num: "6",
        title: "INTELLECTUAL PROPERTY OF THE PLATFORM",
        body: "The trademarks, logos, source code, interface designs, database schemas, and software tools related to the Troly brand are the exclusive property of The Company. Their reproduction, commercial exploitation, or decompilation without prior written authorization is strictly prohibited.",
      },
      s7: {
        num: "7",
        title: "MODIFICATIONS TO THE TERMS",
        body: "The Company reserves the right to update, amend, or replace sections of these Terms and Conditions at any time to adapt them to new legal regulations or operational improvements to the service, such as future market valuation tools or expansion into new collectibles verticals. Modifications will take effect immediately upon publication at the web address (https://troly.club/terminos).",
      },
      s8: {
        num: "8",
        title: "GOVERNING LAW AND JURISDICTION",
        body: "These Terms and Conditions shall be governed and interpreted under the laws of the United Mexican States (Mexico). Any judicial controversy or claim arising from the use of the platform shall be submitted to the competent courts of the State of Mexico, with the parties waiving any other jurisdiction that may correspond to them by current or future domicile.",
      },
      footer_note: "© 2026 TROLY · Constructores de Crecimiento S.A. de C.V.",
    },
    sorteo: {
      meta_title: "Raffle Terms — Troly",
      meta_desc: "Official rules of the raffle for a Hot Wheels Legends Tour 2026 · Ford Mustang Boss 302 among Troly Pro subscribers in Mexico.",
      back_to_home: "Back to home",
      eyebrow: "Troly Raffle · Mexico",
      title: "Win a Hot Wheels Legends Tour 2026",
      prize_name: "Ford Mustang Boss 302 · protector case and shipping included",
      pitch: "Troly is the ideal place for scale car collectors. Organize your cars, discover what you are missing and contribute to a constantly growing database, enriched by the community.",
      cta: "Subscribe to the Troly Pro plan",
      cta_fb: "Follow Troly on Facebook",
      deadline: "Entries open until September 30, 2026, 12:00 PM (Mexico City, UTC-6). Live draw on October 1, 2026.",
      prize_alt: "Hot Wheels Legends Tour 2026 — 69 Ford Mustang Boss 302 in its blister with protector",
      prize_caption: "Prize: Hot Wheels Legends Tour 2026 · Ford Mustang Boss 302",
      steps: {
        title: "How to enter",
        s1_title: "1 · Subscribe to Troly Pro",
        s1_body: "The Troly Pro plan is free. If you later purchase the Troly Premium plan, you are still entered.",
        s2_title: "2 · Upload four pieces",
        s2_body: "Upload four pieces from your collection to your profile and you get your entry number.",
        s3_title: "3 · Invite a friend",
        s3_body: "Every four collectors who register with your TROLY-XXXX code earn you an extra number. Share it from",
        s3_link: "your profile",
      },
      numbers: {
        title: "Assigned numbers",
        loading: "Loading the list…",
        error: "We could not load the entrant list. Please try again in a moment.",
        empty: "No numbers assigned yet. The first to meet the conditions takes number 1.",
        count_one: "{{count}} number issued",
        count_other: "{{count}} numbers issued",
        more: "Show more numbers",
        closed: "Entries are closed. The list below is final.",
        body: "The list of entrants and their numbers is published on this same page (https://troly.club/sorteo). Numbers are issued in activation order, from one (1) up to N, and never change once assigned. One entrant can hold several numbers: one for their four pieces and one more for every four collectors they invite.",
      },
      legal_title: "TERMS AND CONDITIONS OF THE «WIN A HOT WHEELS LEGENDS TOUR 2026» RAFFLE",
      updated: "Last updated: August 2026",
      s1: {
        num: "1",
        title: "ORGANIZER",
        body: "This activity is organized by Troly — Bido, Mexican tax ID (RFC) AAMR6811066U5, domiciled in Naucalpan de Juárez, State of Mexico, Mexico, contact email troly@bido.app.",
      },
      s2: {
        num: "2",
        title: "ELIGIBILITY",
        bullets: [
          "Open to natural persons aged 18 or over.",
          { bold: "Territory:", text: "valid in Mexico only." },
          "Direct organizers and staff involved in auditing the draw are excluded from entering.",
          "Users who submit false information are excluded from the prize.",
          "Seller accounts do not take part in the draw.",
        ],
      },
      s3: {
        num: "3",
        title: "MECHANICS AND NUMBER ASSIGNMENT",
        bullets: [
          "Open to users registered on Troly with the Troly Pro plan, which is free of charge, from the publication date of these rules until September 30, 2026 (12:00 PM). If the user subscribes to Troly Pro and later purchases Troly Premium, they are still entered.",
          { bold: "Base number:", text: "uploading four (4) pieces from your collection to your Troly profile grants one (1) entry number." },
          { bold: "Additional numbers:", text: "for every four (4) collectors who register with your personal invite code (TROLY-XXXX), available on your profile, you receive one (1) additional number. There is no cap on additional numbers." },
          "The four pieces are the entry condition: without them no number is assigned, regardless of how many people you invite.",
          "Entry and numbers activate automatically once the conditions are met: no further steps are needed.",
          "Numbers are issued in activation order, from number one (1) up to number N, and are never reordered or reassigned once granted.",
          "Each draw round requires new referrals and new pieces: contributions already counted in a previous round do not count again.",
          "Following Troly on Facebook is NOT a requirement to enter; the button stays on the page as a community channel.",
          "The list will be published at https://troly.club/sorteo",
        ],
      },
      s4: {
        num: "4",
        title: "PRIZE",
        bullets: [
          { bold: "Description:", text: "one Hot Wheels Legends Tour 2026 — Ford Mustang Boss 302, with protector case and shipping within Mexican territory." },
          { bold: "Conditions:", text: "the prize cannot be exchanged for cash nor transferred to third parties, except with the express authorization of the organizer." },
        ],
      },
      s5: {
        num: "5",
        title: "DRAW DATE AND WINNER SELECTION",
        bullets: [
          "The draw will take place on October 1, 2026 at 12:00 noon (Mexico City time, UTC-6).",
          { bold: "Selection method:", text: "live broadcast on Facebook, where the winning number is drawn among the assigned numbers." },
        ],
      },
      s6: {
        num: "6",
        title: "WINNER NOTIFICATION AND PRIZE DELIVERY",
        bullets: [
          "The winner will be notified within a maximum of 24 hours, by phone and/or email.",
          "The winner has 30 calendar days to provide shipping details or claim the prize in person with an ID document at the Troly address: Residencial Alta Vitta, Anillo Interior 275, Torre F, Apto 301, ZIP 53124, Naucalpan de Juárez, State of Mexico (WhatsApp +52 55 4792 7091).",
          "If the winner does not respond or does not meet the requirements within that period, a new draw will be held among the same subscribers.",
          { bold: "Shipping costs:", text: "shipping, freight, windfall taxes and paperwork are covered by Troly." },
        ],
      },
      s7: {
        num: "7",
        title: "PERSONAL DATA PROCESSING",
        body: "Data provided by entrants will be used exclusively to run the raffle, contact the winner and verify the draw, in accordance with applicable personal data protection regulations.",
      },
      s8: {
        num: "8",
        title: "ACCEPTANCE OF THE RULES",
        body: "Subscribing to the Troly Pro plan implies full and unreserved acceptance of these terms and conditions.",
      },
      regulatory: {
        title: "Regulatory notes by jurisdiction",
        body: "Government permits: our projections for this commercial activity do not amount to a large-scale raffle, the kind that requires prior registration, payment of exploitation fees and compliance bonds before SEGOB. If subscriptions to the Troly marketplace exceed the agreed figures for it to be considered a large-scale raffle, the corresponding filing will be made before the Government of Mexico.",
      },
      footer_note: "© 2026 TROLY · Constructores de Crecimiento S.A. de C.V. · THE SPANISH VERSION OF THESE RULES PREVAILS",
    },
  },
};

export default en;
